var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { Step } from '@shared/claim/steps';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import { ExitTypes } from '@shared/types/api/claim';
const claim = namespace('claim');
const qualification = namespace('qualification');
let ExpertAppointmentOnSiteIndex = class ExpertAppointmentOnSiteIndex extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/appointment/expertOnSite.svg');
    }
    get description() {
        if (this.qualification.irsiApplication === 'non') {
            return this.$tc('appointment.expert.start_screen.description.on_site.irsi');
        }
        if (this.claim.exit === ExitTypes.OnSiteAppointment) {
            return this.$tc('appointment.expert.start_screen.description.on_site.counting');
        }
        return this.$tc('appointment.expert.start_screen.description.on_site.complex');
    }
    async acceptAppointment() {
        await this.updateAndSaveClaimStep(Step.ExpertAppointmentOnSiteIndex);
    }
};
__decorate([
    claim.Action('updateAndSaveClaimStep')
], ExpertAppointmentOnSiteIndex.prototype, "updateAndSaveClaimStep", void 0);
__decorate([
    claim.State('claim')
], ExpertAppointmentOnSiteIndex.prototype, "claim", void 0);
__decorate([
    qualification.State('qualification')
], ExpertAppointmentOnSiteIndex.prototype, "qualification", void 0);
ExpertAppointmentOnSiteIndex = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
            goBack: null,
        },
    })
], ExpertAppointmentOnSiteIndex);
export default ExpertAppointmentOnSiteIndex;
